<!-- 用户管理 -->
<template>
  <div class="application-manage">
    <div class="table-header">
      <a-form :layout="'horizontal'" class="page-search" :colon="true">
        <a-row :gutter="20">
          <a-col span="6">
            <a-form-item
              label="姓名"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.userRealName"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="UkeyID"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.userKey"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="账号"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.loginAccount"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="身份证号"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.userIdCard"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="手机号"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.phone"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="所属机构"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <LenovoSelectModule
                :reset="true"
                placeholder="请输入"
                v-model="params.orgName"
                apiType="getPubOrganName"
                modelKey="name"
                :paramsListObj="{ name: 'name', id: 'id' }"
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="所属部门"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.departmentName"
                allowClear
              />
              <!-- <LenovoSelectModule
                :reset="true"
                placeholder="请输入"
                v-model="params.departmentName"
                apiType="getPubDeptName"
                modelKey="name"
                :paramsListObj="{ name: 'name', id: 'id' }"
              /> -->
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="授权应用"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.appId"
                apiType="getAllAppInfo"
                autoValue="id"
                autoLabel="appShortName"
                @change="handleChange"
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.accountStatus"
                apiType="getDictDataByCode"
                :apiParams="{ dictCode: 'account_status' }"
              />
            </a-form-item>
          </a-col>

          <a-col class="flag" span="12" :offset="6">
            <a-button @click="onReset"
              ><a-icon type="reload" style="color: #585d68" />重置</a-button
            >
            <a-button type="primary" @click="handleSearch"
              ><IconSvg iconData="search" />查询</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-concent">
      <div class="concent-buts">
        <a-button
          type="primary"
          @click="handleTableRow(true)"
          v-if="
            userInfo.userId === '1HIL1UMQ2LK9981EH0K0NUT8770011QH' ||
            userInfo.userId === '1HIN01RJOD0I9N66PFIKSBL1PF0016GC' ||
            userInfo.userId === '1HIN01SPVR8QDF66PFIKSBL1RB0016I8'
          "
          ><a-icon type="plus" />新增</a-button
        >
      </div>
      <TableList
        :columns="columns"
        :tableData="tableData"
        :loading="loading"
        :pageInfo="pageBean"
        @getList="changePage"
      >
        <div slot="action" slot-scope="record" class="columns-action">
          <a-button type="link" @click="handleTableRow(true, record.scope)"
            >编辑</a-button
          >
          <a-button type="link" @click="showSendConfirm(record.scope)">{{
            record.scope.accountStatus == "0" ? "停用" : "启用"
          }}</a-button>
          <a-button type="link" @click="showDeletConfirm(record.scope)"
            >删除</a-button
          >
          <a-button type="link" @click="showReset(record.scope)"
            >重置密码</a-button
          >
        </div>
      </TableList>
    </div>

    <AddEdit
      :modalFlag="modalFlag"
      :modalData="modalData"
      @handleFlag="handleTableRow"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import InputText from "@/components/form/InputText"; // 输入框组件
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import TableList from "@/components/table/TableList"; // 表格组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
import API from "@/api/sysManage.js"; // 请求接口
import AddEdit from "./components/AddEdit.vue";

import "./index.less";

export default {
  components: {
    InputText,
    SelectModule,
    TableList,
    LenovoSelectModule,
    AddEdit,
  },
  computed: {
    ...mapState(["userInfo"]),
    columns() {
      const columns = [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          fixed: "left",
          ellipsis: true,
          customRender: (text, row, index) => {
            return (
              (this.pageBean.pageNum - 1) * this.pageBean.pageSize + index + 1
            );
          },
        },
        {
          title: "姓名",
          dataIndex: "userRealName",
          key: "userRealName",
          ellipsis: true,
          scopedSlots: { customRender: "userRealName" },
        },
        {
          title: "UkeyID",
          dataIndex: "userKey",
          key: "userKey",
          ellipsis: true,
          scopedSlots: { customRender: "userKey" },
        },
        {
          title: "账号",
          dataIndex: "loginAccount",
          key: "loginAccount",
          ellipsis: true,
          scopedSlots: { customRender: "loginAccount" },
        },
        {
          title: "身份证号",
          dataIndex: "userIdCard",
          key: "userIdCard",
          ellipsis: true,
          scopedSlots: { customRender: "userIdCard" },
        },
        {
          title: "手机号",
          dataIndex: "phone",
          key: "phone",
          ellipsis: true,
          scopedSlots: { customRender: "phone" },
        },
        {
          title: "所属机构",
          dataIndex: "orgName",
          key: "orgName",
          ellipsis: true,
          scopedSlots: { customRender: "orgName" },
        },
        {
          title: "所属部门",
          dataIndex: "departmentName",
          key: "departmentName",
          ellipsis: true,
          scopedSlots: { customRender: "departmentName" },
        },
        {
          title: "角色",
          dataIndex: "roleName",
          key: "roleName",
          ellipsis: true,
          scopedSlots: { customRender: "roleName" },
        },
        {
          title: "授权应用",
          dataIndex: "appShortName",
          key: "appShortName",
          ellipsis: true,
          scopedSlots: { customRender: "appShortName" },
        },
        {
          title: "状态",
          dataIndex: "accountStatusDesc",
          key: "accountStatusDesc",
          width: 50,
          ellipsis: true,
          // scopedSlots: { customRender: "accountStatusDesc" },
        },
        {
          title: "操作",
          dataIndex: "actions",
          key: "actions",
          width: 240,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ];
      return columns;
    },
  },
  data() {
    return {
      loading: false, // 是否加载
      pageBean: {
        // 自定义分页
        pageNum: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
      },
      params: {
        userRealName: "",
        accountStatus: "",
        orgName: "",
        phone: "",
        loginAccount: "",
        departmentName: "",
        userIdCard: "",
        userKey: "",
        queryType: "1",
        appId: "", // 授权app简称id
        // appShortName: "", // 授权app简称
      },
      tableData: [], // 列表数据
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      modalFlag: false, // 弹层状态
      modalData: {}, // 表格选中数据
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    // 选择授权应用name
    handleChange(id, option) {
      // this.params.appShortName = option.name;
    },
    // 查询
    handleSearch() {
      this.getData(1);
    },
    // 获取列表数据
    getData(pageNum) {
      this.loading = true;
      let params = {
        data: {
          pageBean: {
            pageNum: pageNum,
            pageSize: this.pageBean.pageSize,
          },
          params: {
            ...this.params,
            isAdmin: "1",
          },
        },
      };
      API.queryUserList(params, (callback) => {
        this.loading = false;
        let list = []; // 数据
        if (callback.status == "S" && callback.data) {
          const backData = callback.data;
          const pageBean = { ...this.pageBean };
          pageBean.total = backData.total || 0;
          pageBean.pageNum = pageNum || 1;
          this.pageBean = pageBean;

          if (Array.isArray(backData.list) && backData.list.length > 0) {
            backData.list.map((item, index) => {
              // item.key = item.id;
              item.key = index;
            });
            list = backData.list;
          }
          this.tableData = list;
        }
      });
    },
    // 分页事件
    changePage(page, filters, sorter) {
      this.pageBean.pageNum = page.current || 1;
      this.pageBean.pageSize = page.pageSize || 10;
      this.getData(this.pageBean.pageNum);
    },
    // 重置
    onReset() {
      this.params = {
        userRealName: "",
        accountStatus: "",
        orgName: "",
        phone: "",
        loginAccount: "",
        departmentName: "",
        userIdCard: "",
        userKey: "",
        queryType: "1",
        appId: "", // 授权app简称id
        // appShortName: "", // 授权app简称
      };
      this.handleSearch();
    },
    // 查看详情
    handleTableRow(flag, row, status) {
      this.modalFlag = flag;
      this.modalData = row || {};
      if (status == "ok") {
        this.getData(1);
      }
    },
    // 删除
    showDeletConfirm(row) {
      let _this = this;
      this.$confirm({
        title: "是否确定删除当前的用户?",
        content: (h) => <div style=""></div>,
        onOk() {
          const params = {
            data: {
              params: {
                id: row.id,
                isAdmin: "1",
              },
            },
          };
          API.deleteUser(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success("删除成功");
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
    // 重置
    showReset(row) {
      API.getResetLoginPwd({}, (callback) => {
        let pwd = "";
        if (callback.status == "S") {
          pwd = callback.data.userPwd || "";

          this.getNewPwd(row, pwd);
        }
      });
    },
    getNewPwd(row, pwd) {
      // console.log("pwd", pwd);
      let params = {
        data: {
          params: {
            id: row.id,
            userPwd: pwd,
            isAdmin: "1",
          },
        },
      };
      let _this = this;
      this.$confirm({
        title: `是否确定将当前账号<${row.userRealName}>的密码重置成${pwd}`,
        content: (h) => <div style=""></div>,
        onOk() {
          API.resetLoginPwd(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success("重置密码成功");
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
    // 停用/撤回
    showSendConfirm(row) {
      let _this = this;
      this.$confirm({
        title: `是否确定${
          row.accountStatus == "0" ? "停用" : "启用"
        }当前的用户?`,
        content: (h) => <div style=""></div>,
        onOk() {
          const params = {
            data: {
              params: {
                id: row.id,
                accountStatus: row.accountStatus == "0" ? "1" : "0",
                isAdmin: "1",
              },
            },
          };
          API.updateUserStatus(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success(
                `${row.accountStatus == "0" ? "停用" : "启用"}成功`
              );
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
  },
};
</script>
